<template>
  <div class="py-4 container-fluid">
    <div class="row">
      <div class="col-12 d-flex justify-content-between">
        <div class="d-flex align-items-center">
          <h4 class="text-uppercase mb-0">Sleep</h4>
          <a href="/help/knowledgebase?section=sleep" target="_blank">
            <img src="/img/icons/ic_info.svg" alt="About Sleep" class="ms-2" /></a>
        </div>
        <div>
          <Datepicker id="dpSleep" v-model="dtRange" dark range auto-range="6" :format="dtRangeFormat"
            :enable-time-picker="false" :max-date="new Date()" />
        </div>
      </div>
      <div class="col-12 mt-3">
        <sleep-by-day-section-chart v-if="chartSleepRanges" id="chartSleepRanges" header="Sleep Score Ranges"
          title="All Sections" height="480" :selected-section-id="selectedSection" :period="dtRange"
          :data-sleep-ranges="dataSleepRanges" :data-sleep="dataSleep" :chart="chartSleepRanges" @selected-section-id="
            (selectedValue) => (selectedSection = selectedValue)
          " @selected-page="(selectedValue) => (page = selectedValue)"
          @selected-sort="(selectedValue) => (sort = selectedValue)"
          @selected-order="(selectedValue) => (order = selectedValue)" @selected-platoon-id="
            (selectedValue) => (selectedPlatoon = selectedValue)" :selected-platoon-id="selectedPlatoon" />
      </div>
    </div>

    <div class="row mt-4">
      <div class="col-12">
        <sleep-section-chart v-if="chartSleepSection" id="chartSleepSection"
          header="Average Sleep Score and Hours Of Sleep" title="ALPHA" height="480"
          :selected-section-id="selectedSection" :period="dtRange" :data-sleep-hours="dataSleepHours"
          :chart="chartSleepSection" @selected-section-id="
            (selectedValue) => (selectedSection = selectedValue)" />

        <sleep-debt-need-combo-chart v-if="sleepDebtAndNeededData.length > 0"  id="sleepDebtAndNeededChart"
          header="SLEEP DEBT" :selectedSection="selectedSectionName" height="480" :rows="sleepDebtAndNeededData"
          :selected-section-id="selectedSection"  /> 
      </div>
    </div>
  </div>
</template>
<script>
const dayjs = require("dayjs");
import Constants from "@/helpers/constants";
import ChartUtils from "@/helpers/chartUtils";
import Utils from "@/helpers/utils";
import Datepicker from "@vuepic/vue-datepicker";
import SleepByDaySectionChart from "./components/SleepByDaySectionChart.vue";
import SleepSectionChart from "./components/SleepSectionChart.vue";
import SleepDebtNeedComboChart from "./components/sleep/SleepDebtNeedComboChart.vue";
import styles from "./Sleep.vue?vue&type=style&index=0&lang=scss&module=1";

export default {
  name: "Sleep",
  components: {
    SleepByDaySectionChart,
    SleepSectionChart,
    Datepicker,
    SleepDebtNeedComboChart,
  },
  data() {
    return {
      dtRangeFormat: Constants.DATE_RANGE_FORMAT,
      page: Constants.DEFAULT_PAGE,
      pageSize: 10,
      sort: "status_end_time",
      order: "desc",
      selectedSection: Constants.DEFAULT_SECTION,
      dtRange: [dayjs().subtract(6, "days"), dayjs()],
      dataSleepRanges: [],
      dataSleep: [],
      dataSleepFeatures: [],
      dataSleepHours: [],
      chartSleepRanges: {
        labels: [],
        datasets: [],
      },
      chartSleepSection: {
        labels: [],
        datasets: [],
      },
      selectedPlatoon: Constants.DEFAULT_PLATOON,
      sleepDebtAndNeededData: [],
      selectedSectionName: "All Sections",
    };
  },
  watch: {
    dtRange() {
      if (!this.dtRange) {
        this.dtRange = [dayjs().subtract(6, "days"), dayjs()];
      }
      this.getDataSleepRanges();
      this.getDataSleepHours();
    },
    selectedSection() {
      this.getDataSleepRanges();
      this.getDataSleepHours();
      this.selectedSectionName = this.getSectionName(this.selectedSection) || "All Sections";
      console.log("Selected Section changed to:", this.selectedSection); 
    },
    page() {
      this.getDataSleep();
    },
    sort() {
      this.getDataSleep();
    },
    order() {
      this.getDataSleep();
    },
  },
  mounted() {
    this.getDataSleepRanges();
    this.getDataSleepHours();
  },
  methods: {
    getDataSleepRanges() {
      this.$store
        .dispatch("data/sleepRangesBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0])
            .utc()
            .startOf("day")
            .format(Constants.BUCKET_FORMAT),
          dt_to: dayjs(this.dtRange[1])
            .utc()
            .endOf("day")
            .format(Constants.BUCKET_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataSleepRanges = data.data;
          this.updateChartData();
          this.getDataSleep();
        });
    },
    getDataSleep() {
      this.$store
        .dispatch("data/sleepDataBySection", {
          page: this.page,
          page_size: this.pageSize,
          sort: this.sort,
          order: this.order,
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0]).utc().format(Constants.DB_FORMAT),
          dt_to: dayjs(this.dtRange[1]).utc().format(Constants.DB_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          console.log('getSleepData Response', data);
          if(data && data.data){
            this.dataSleep = data.data.dataSleep;
            this.dataSleepFeatures = data.data.dataSleepFeatures;
          } else {
            this.dataSleep = [];
            this.dataSleepFeatures = [];
            this.sleepDebtAndNeededData = [];
          }
          this.prepareSleepDebtNeededData();
        });
    },
    prepareSleepDebtNeededData() {
      // Placeholder for future implementation
      console.log("prepareSleepDebtNeededData called with dataSleepFeatures:", this.dataSleepFeatures);
      this.sleepDebtAndNeededData = [];
      for(let row of this.dataSleepFeatures.rows) {
        let userName = row.user && row.user[0] && row.user[0].name ? row.user[0].name : "Unknown";
        let sleepNeedPct = row.avg_sleep_need ? Math.round((row.avg_sleep_mins/row.avg_sleep_need) * 100) : 0;
        this.sleepDebtAndNeededData.push({
          name: userName,
          sleepDebtMinutes: row.avg_sleep_debt || 0,
          sleepNeedPct: sleepNeedPct,
        });
      }
      console.log("Prepared sleepDebtAndNeededData:", this.sleepDebtAndNeededData);
    },
    getDataSleepHours() {
      this.$store
        .dispatch("data/sleepHoursBySection", {
          section_id: this.selectedSection || -1,
          dt_from: dayjs(this.dtRange[0]).utc().format(Constants.DB_FORMAT),
          dt_to: dayjs(this.dtRange[1]).utc().format(Constants.DB_FORMAT),
          platoon_id: this.selectedPlatoon,
        })
        .then((data) => {
          this.dataSleepHours = data.data;
          this.updateSleepSectionChart();
        });
    },
    updateChartData() {
      this.chartSleepRanges = Object.assign(
        {},
        ChartUtils.dataRangesChart(this.dataSleepRanges)
      );
    },
    updateSleepSectionChart() {
      let colorSleep = {
        rem: styles.colorRemSleep,
        deep: styles.colorDeepSleep,
        light: styles.colorLightSleep,
        awake: styles.colorAwake,
      };
      this.chartSleepSection = Object.assign(
        {},
        ChartUtils.sleepHoursChart(this.dataSleepHours, colorSleep)
      );
    },
    formatPeriod(period) {
      return Utils.formatPeriod(period);
    },
     getSectionName(section_id) {
      const section = this.$store.getters["list/getSectionName"](section_id);
      return section ? section.name : "";
    },
  },
};
</script>
<style lang="scss" scoped>
:export {
  colorLightSleep: $color-sleep-light;
  colorRemSleep: $color-sleep-rem;
  colorDeepSleep: $color-sleep-deep;
  colorAwake: $color-sleep-awake;
}
</style>
